

import { createContext } from 'react';

const CodesContext = createContext();

export default CodesContext;